<template lang="pug">
  .width-100.m-top-2.m-bottom-4
    h2.title-medium {{ $t(`feed.seeMore.sections.${section}`) }}
    section.grid.gap-20.m-top-2.relative(v-if='!firstLoading' :class='getColumns(sectionType)')
      resource-card(
        v-if='sectionType === "resource" && (!firstLoading || loading)'
        v-for='resource in contentSections[section].data'
        :key='resource.id'
        noMargin
        :resource='resource'
        :bookmarked='resource.isInAnyFolder'
      )
      educational-program-card(
        v-if='sectionType === "program" && (!firstLoading || loading)'
        v-for='program in contentSections[section].data'
        :key='program.id' noMargin
        :program='program'
      )
      kimple-folder-card(
        v-if='sectionType === "foldersRecommended" && (!firstLoading || loading)'
        v-for='(folder, index) in contentSections[section].data'
        :key='folder.id'
        :kimpleFolder='folder'
        :index='index'
      )
      kimple-folder-feed(
        v-if='sectionType === "folder" && (!firstLoading || loading)'
        v-for='folder in contentSections[section].data'
        noMargin
        :key='folder.id'
        :folder='folder'
        @copyFolder='copyFolder'
      )
      topic-card(
        v-if='sectionType === "topic" && (!firstLoading || loading)'
        v-for='topic in contentSections[section].data'
        :key='topic.id'
        :topic='topic'
      )
      ephemeride-card(
        v-if='sectionType === "ephemeride" && (!firstLoading || loading)'
        v-for='folder in contentSections[section].data'
        :key='folder.id'
        :id='folder.id'
        :image='folder.feedThumbnail'
        :name='folder.title'
        :startDate='folder.startDate'
        :folderLocale='folder.selectedLocale'
      )
    section.grid.gap-20.relative.m-top-2(v-if='firstLoading || loading' :class='getColumns(sectionType)')
      loader.absolute(size="inner")
      sk-educational-program-card(v-if='sectionType === "program"' v-for='n in 8')
      sk-resource-card(v-if='sectionType === "resource"' v-for='n in 8')
      sk-kimple-folder-card(v-if='sectionType === "foldersRecommended"' v-for='n in 6')
      sk-folder-card(v-if='sectionType === "folder"' v-for='n in 8')
      sk-sdg-card(v-if='sectionType === "sdg"' v-for='n in 10')
      sk-ephemeride-card(v-if='sectionType === "ephemeride"' v-for='n in 6')
    .row.middle.center.width-100.m-top-2
      button.text-normal.bold.blue(
        v-if='canShowMore'
        @click='loadMore'
      ) {{ $t("feed.seeMore.seeMore") }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SkResourceCard from '../SkResourceCard'
import SkFolderCard from '../SkFolderCard'
import SkSdgCard from '../SkSdgCard'
import SkEphemerideCard from '../SkEphemerideCard'
import ResourceCard from '../ResourceCard'
import KimpleFolderFeed from '../KimpleFolderFeed'
import SdgCard from '../SDGCard'
import EphemerideCard from '../EphemerideCard'
import KimpleFolderCard from '@/components/KimpleFolderCard'
import SkKimpleFolderCard from '../SkKimpleFolderCard'
import EducationalProgramCard from '../EducationalProgramCard'
import SkEducationalProgramCard from '../SkEducationalProgramCard'
import Loader from '../Loader'
import userRole from '@/mixins/userRole'

export default {
  mixins: [userRole],
  components: {
    Loader,
    EducationalProgramCard,
    SkEducationalProgramCard,
    KimpleFolderCard,
    SkKimpleFolderCard,
    SkResourceCard,
    SkFolderCard,
    SkSdgCard,
    SkEphemerideCard,
    ResourceCard,
    KimpleFolderFeed,
    SdgCard,
    EphemerideCard
  },
  data() {
    return {
      firstLoading: true,
      loading: false,
      sections: [
        {
          name: 'ephemeride',
          type: 'ephemeride',
          pageSize: 3,
          columns: 3
        },
        {
          name: 'foldersRecommended',
          type: 'foldersRecommended',
          pageSize: 3,
          columns: 3
        },
        {
          name: 'mostViewedKimpleFolders',
          type: 'folder',
          limit: 8,
          columns: 4
        },
        {
          name: 'lastFolders',
          type: 'folder',
          limit: 8,
          columns: 4
        },
        {
          name: 'educationalPrograms',
          type: 'program',
          pageSize: 4,
          columns: 4
        },
        {
          name: 'resources',
          type: 'resource',
          pageSize: 4,
          columns: 4
        },
        {
          name: 'latestResourcesSeen',
          type: 'resource',
          limit: 8,
          columns: 4
        },
        {
          name: 'mostViewedResources',
          type: 'resource',
          limit: 8,
          columns: 4
        },
        {
          name: 'newestResources',
          type: 'resource',
          pageSize: 4,
          columns: 4
        },
        {
          name: 'lastPrograms',
          type: 'program',
          pageSize: 4,
          columns: 4
        }
      ]
    }
  },
  beforeDestroy() {
    this.clearFeedSections()
  },
  async created() {
    this.firstLoading = true
    const section = this.sections.find(sec => sec.name === this.section)
    await this.hydrateFeedSection({
      sectionName: section.name,
      isCustom: this.isCustom,
      pageNumber: 0,
      pageSize: section.pageSize * 2,
      limit: section.limit
    })
    this.firstLoading = false
  },
  computed: {
    ...mapState({
      contentSections: state => state.newFeed.sections
    }),
    canShowMore() {
      if (this.sections.find(sec => sec.name === this.section).limit) return false
      if (this.section === 'ephemeride' && this.contentSections[this.section].page === 2) return false
      else {
        return !this.firstLoading &&
       !this.loading &&
       (this.contentSections[this.section].page + 1 < this.contentSections[this.section].totalPages)
      }
    },
    section() {
      return this.$route.query.section
    },
    sectionType() {
      return this.sections.find(sec => sec.name === this.section).type
    }
  },
  methods: {
    ...mapActions([
      'hydrateFeedSection',
      'clearFeedSections'
    ]),
    getColumns(sectionType) {
      return `grid-columns-${this.sections.find(sec => sec.type === sectionType).columns}`
    },
    async loadMore() {
      this.loading = true
      const section = this.sections.find(sec => sec.name === this.section)
      await this.hydrateFeedSection({
        sectionName: section.name,
        isCustom: this.isCustom,
        pageNumber: this.contentSections[section.name].page + 1,
        pageSize: section.pageSize * 2
      })
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
